module.exports = __webpack_public_path__ + "img/tacos.80dede55.png";